<template>
  <QButtonGroup v-model="technicianpartfilter" :list="technicianPartFilterOptions" :edit="true" dense noempty>
  </QButtonGroup>
</template>


<script>
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";

export default {
  name: "TechnicianPartFilter",
  props: {
    pk: String,
    defaultToActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  mixins: [FilterQueryMixin],

  data() {
    return {
      technicianPartFilterOptions: [
        { value: 0, text: this.$t("servicesystem.common_objects.commonterms.any") },
        { value: 1, text: this.$t("servicesystem.common_objects.commonterms.yes") },
        { value: -1, text: this.$t("servicesystem.common_objects.commonterms.no") },
      ],
    };
  },

  methods: {},

  computed: {
    technicianpartfilter: {
      get() { return this.getQueryParam("filter-technicianpart", 0); },
      set(update) { this.setQueryParam("filter-technicianpart", update); },
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>